import {Inject, Injectable} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {AddressesActions} from "./addresses.actions";
import {ChatActions} from "../../../chat/state/chat.actions";
import {selectAddressId} from "./addresses.state";
import {AddressRequestType} from "../types/address-request.type";

@Injectable()
export class AddressFacadeService {

  constructor(@Inject(Store) private store: Store<any>) {

  }


  selectAddressId() {
    return this.store.pipe(select(selectAddressId));
  }

  setAddressId(id?: string, query?: any, type?: AddressRequestType) {
    this.store.dispatch(AddressesActions.setAddressId({id: id, query: query, resolveType: type}));
  }
}
